import * as THREE from "three";
import { useRef, useEffect } from 'react'
import { useGLTF } from "@react-three/drei";
import { useLoader } from "@react-three/fiber";
import { TextureLoader } from "three/src/loaders/TextureLoader";
import { MeshBasicMaterial } from "three";


export default function TableSmall(props) {

  const positions = [
    [1.3773, 0.558069, -5.07835],
    [1.3773, 0.558069, -6.69049],
    [12.0698, 0.558069, 7.24021],
  ];

    const ref = useRef()
    const temp = new THREE.Object3D()
    useEffect(() => {
      // Set positions
      for (let i = 0; i < positions.length; i++) {
        temp.position.set(positions[i][0], positions[i][1], positions[i][2])
        temp.updateMatrix()
        ref.current.setMatrixAt(i, temp.matrix)
      }
      // Update the instance
      ref.current.instanceMatrix.needsUpdate = true
    }, [positions])
    const { nodes } = useGLTF("models/TableSmall.glb");
    const [texture] = useLoader(TextureLoader, ["textures/" + (props.isMobile ? "Textures_Quarter/" : "") + "BigTables_Bake1_CyclesBake_COMBINED_ergebnis.webp",
    ]);
  
    texture.flipY = false;
    texture.colorSpace = THREE.SRGBColorSpace;
    const Material = new MeshBasicMaterial();
    Material.side = THREE.DoubleSide;
    Material.map = texture;
    Material.toneMapped = false;
    Material.needsUpdate = true;
    
  return(
      <instancedMesh ref={ref} args={[nodes.TableSmall001.geometry, Material, positions.length]}/>
    )
  }

  useGLTF.preload("models/TableSmall.glb");